<template>
  <div class="msboxwrapper">
    <div class="container">
      <div class="mboxtitle col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="header-title" :id="'dragHeader'+patient.id">
          <h2 class="notesTitle">
            <b>{{ patient.firstName + " " + patient.lastName }} ({{ patient.dob }})</b>
          </h2>
        </div>
        <div class="header-first">
          <select id="note-type" class="note-type" v-model="noteType">
            <option value="Nursing">Nursing Note</option>
            <option value="Providers">Providers Note</option>
            <option v-if="$route.name == 'MedAdminNavigation'" value="9898X">
              Therapeutic Monitoring (CPT 9897X)
            </option>
            <option v-if="$route.name == 'VitalsGroup'" value="9945X">
              Physiologic Monitoring (CPT 9945X)
            </option>
          </select>
          <div class="startDateTime">
            <b>{{ noteType != "Nursing" && noteType != "Providers" ? "Date" : "Start" }} </b>
            <input type="date" id="startDt" name="startDt" v-model="startDt" required />
            <input
              type="time"
              id="startTime"
              name="startTime"
              v-model="startTime"
              required
            />
          </div>
        </div>
        <div v-if="noteType == 'Nursing' || noteType == 'Providers'" class="header-second">
          <div class="endDateTime">
            <b>End </b>
            <input type="date" id="endDt" name="endDt" v-model="endDt" required />
            <input type="time" id="endTime" name="endTime" v-model="endTime" required />
          </div>
        </div>
        <!-- <span class="noteTimer" v-if="noteType == 'Vitals' || noteType == '9898X' || noteType == '9945X'">{{ showTime() }}</span> -->
        <div id="msglbl" class="notemsglbl"></div>
      </div>
      <div class="msgbox col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <form action="" method="POST">
          <editor
            v-model="message"
            api-key="wtyerkxnsy7pxhf40g1mq9tjlifsy2ygztyau951df686zv9"
            :init="{
              height: 300,
              plugins: [
                'advlist',
                'autolink',
                'lists',
                'link',
                'image',
                'charmap',
                'preview',
                'anchor',
                'searchreplace',
                'visualblocks',
                'fullscreen',
                'insertdatetime',
                'media',
                'table',
                'help',
                'wordcount',
              ],
              toolbar:
                'undo redo | casechange blocks | bold italic backcolor | ' +
                'alignleft aligncenter alignright alignjustify | ' +
                'bullist numlist checklist outdent indent | removeformat | code table help',
            }"
          />
          <div class="last-note-title">
            <span>Latest {{ this.noteType }} Notes</span>
          </div>
          <div v-if="noteList.length != 0" class="note-list">
            <div
              v-for="(note, index) in filterNotes()"
              class="note-item"
              @click="showContents(note.pnotes)"
              :key="'note' + index"
            >
              <span class="noteList-left">{{ note.startDt }}</span>
              <span class="noteList-right">{{ note.name }}</span>
            </div>
          </div>
          <span
            class="noteTimer"
            v-if="noteType == 'Vitals' || noteType == '9898X' || noteType == '9945X'"
            >{{ showTime() }}</span
          >
          <select
            id="template-chooser"
            class="template-chooser"
            v-model="noteTemplateSelector"
            @change="message = noteTemplates[noteTemplateSelector]"
          >
            <option v-for="(value, key) in noteTemplates" :key="key" :value="key">
              {{ key }}
            </option>
          </select>
          <select
            id="group-chooser"
            class="group-chooser"
            v-model="selectedGroup"
            @change="groupSelected"
          >
            <option default value="0">Select Group</option>
            <option v-for="(value, key) in groupList" :key="key" :value="key">
              {{ value.groupname }}
            </option>
          </select>
          <label
            >E-mail Patient<input type="checkbox" id="notifyptchkbx" v-model="notify"
          /></label>
          <input
            type="button"
            value="Cancel"
            id="cnclbtn"
            class="modalcancelbtn"
            @click="removeNote"
          />
          <input
            type="button"
            value="Save Draft"
            id="draftbtn"
            class="modaldraftbtn"
            @click="draftNote"
          />
          <input
            type="button"
            value="Save"
            id="msgbtn"
            class="modalbtn"
            @click="saveNote"
          />
        </form>
      </div>
    </div>
    <div v-if="popupText" class="text-popup">
      <div class="outer-container">
        <div class="text-content">
          <p v-html="popupText"></p>
        </div>
      </div>
      <div class="btn-group">
        <button type="button" class="notebtn btn btn-secondary" @click="closeContents">
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { CURR_API, OTHER_API } from "@/constants/apis";
import { domRoot } from "@/api/SERVER_ADDR"
import { getNotes, deleteNotes, updateNotes } from "@/api/userApi";
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";
import noteTemplates from "@/constants/templates";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "NotePopup",
  data() {
    return {
      message: "",
      notify: false,
      startDt: null,
      endDt: null,
      startTime: null,
      endTime: null,
      noteTemplateSelector: "Templates",
      noteTemplates: noteTemplates,
      noteList: [],
      popupText: "",
      noteType: this.type,
      groupList: {},
      selectedGroup: 0,
      runningTime: 0,
      interval: null,
    };
  },
  components: {
    editor: Editor,
  },
  props: {
    patient: {},
    type: String,
  },
  async mounted() {
    // let today = new Date().toISOString().substring(0, 10);
    // this.startDt = today
    // this.endDt = today

    let noteGetter = {
      userid: this.user.id,
      patientid: this.patient.id + "",
    };
    getNotes(noteGetter).then((res) => {
      if (res[0]) {
        if (res[0].data2) {
          this.message = res[0].data2;
        }
        if (res[0].data) {
          let dates = JSON.parse(res[0].data);
          this.startDt = dates.startDt;
          this.endDt = dates.endDt;
          this.startTime = dates.startTime;
          this.endTime = dates.endTime;
        }
      }
    });
    this.getAllNotes();
    this.getGroups();
    this.dragNote(document.getElementById('note__popup'+this.patient.id))
  },
  computed: {
    ...mapGetters("login", {
      user: "getUser",
    }),
    ...mapGetters("login", {
      allData: "getAllData",
    }),
  },
  methods: {
    dragNote(el) {
      // console.log(el)
      var pos1 = 0,
        pos2 = 0,
        pos3 = 0,
        pos4 = 0;
      document.getElementById("dragHeader"+this.patient.id).onmousedown = dragMouseDown;

      function dragMouseDown(e) {
        // e.preventDefault();
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
      }

      function elementDrag(e) {
        // e.preventDefault();
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        // set the element's new position:
        el.style.top = el.offsetTop - pos2 + "px";
        el.style.left = el.offsetLeft - pos1 + "px";
      }

      function closeDragElement() {
        /* stop moving when mouse button is released:*/
        document.onmouseup = null;
        document.onmousemove = null;
      }
    },
    startTimer() {
      this.interval = setInterval(() => {
        this.runningTime += 1;
      }, 1000);
    },
    showTime() {
      let time = this.runningTime;
      let hours = Math.floor(time / 3600);
      let newTime = time % 3600;
      let minutes = Math.floor(newTime / 60);
      let seconds = newTime % 60;
      if (minutes < 10) minutes = "0" + minutes;
      if (seconds < 10) seconds = "0" + seconds;
      return "" + hours + ":" + minutes + ":" + seconds;
    },
    filterNotes() {
      if (window.innerWidth <= 575) {
        return this.noteList.filter((note) => note.type == this.noteType).slice(0, 1);
      }
      return this.noteList.filter((note) => note.type == this.noteType).slice(0, 5);
    },
    groupSelected() {
      console.log(this.groupList[this.selectedGroup]);
    },
    async sendGroupEmail() {
      let list = this.groupList[this.selectedGroup].providerslist;
      let emails = [];
      for (const prov in list) {
        emails.push(list[prov].email);
      }
      let content = {
        Provider: {
          API_Meth: "SendProviderEmail",
          toemail: emails.join(),
          subject: `Note from ${this.allData.manager ? this.allData.manager.name : this.user.firstName + " " + this.user.lastName}`,
          message:
            `<h2>Please <a href=\"${domRoot}\">login</a> and review</h2>`,
          provider: this.allData.manager
            ? this.allData.manager.name
            : this.user.firstName + " " + this.user.lastName,
        },
      };
      // console.log(content)
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.message == "EmailSent") {
            alert(
              "The note for " +
                this.patient.firstName +
                " " +
                this.patient.lastName +
                " has been saved. An e-mail notification has been sent."
            );
            let note = document.getElementById("note__popup" + this.patient.id);
            note.style.display = "none";
            this.noteTemplateSelector = "Templates";
            this.message = "";
            this.startTime = this.endTime = this.startDt = this.endDt = null;
            // let today = new Date().toISOString().substring(0, 10);
            // this.startDt = today
            // this.endDt = today
          } else {
            alert(
              "Error with sending an e-mail to this group. Please alert an administrator."
            );
          }
        });
    },
    showContents(text) {
      this.popupText = text;
    },
    closeContents() {
      this.popupText = "";
    },
    async getGroups() {
      let content = {
        Provider: {
          API_Meth: "GetProviderGroup",
          accountnumber: this.patient.externId,
          groupowner: this.allData.manager
            ? this.allData.manager.name
            : this.user.firstName + " " + this.user.lastName,
          grouptype: "",
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          this.groupList = res.data.group;
        });
    },
    async getAllNotes() {
      let content = {
        Note: {
          API_Meth: "GetAllNotes",
          patientID: this.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          this.noteList = res.data.data;
        });
    },
    draftNote() {
      let note = document.getElementById("note__popup" + this.patient.id);
      note.style.display = "none";
      let noteDraft = {
        userid: this.user.id,
        patientid: this.patient.id + "",
        timestamps: {
          startDt: this.startDt,
          endDt: this.endDt,
          startTime: this.startTime,
          endTime: this.endTime,
        },
        draft: this.message,
      };
      updateNotes(noteDraft).then((res) => {
        // console.log(res)
      });
      this.noteTemplateSelector = "Templates";
      this.runningTime = 0;
      clearInterval(this.interval);
    },
    removeNote() {
      let note = document.getElementById("note__popup" + this.patient.id);
      note.style.display = "none";
      this.message = "";
      this.startTime = this.endTime = null;
      let today = new Date().toISOString().substring(0, 10);
      this.startDt = today;
      this.endDt = today;
      this.noteTemplateSelector = "Templates";
      let draftDel = {
        userid: this.user.id,
        patientid: this.patient.id + "",
      };
      deleteNotes(draftDel).then((res) => {
        // console.log(res)
      });
      this.runningTime = 0;
      clearInterval(this.interval);
    },
    showOrder() {
      let order = document.getElementById("order__popup" + this.patient.id);
      order.style.display = "flex";
    },
    async saveNote() {
      // console.log(this.message, this.notify)
      if (!this.message) {
        alert("There is no message to save.");
        return;
      }
      let loader = this.$loading.show(
        {},
        {
          after: this.$createElement("div", {}, ["Saving your note..."]),
        }
      );
      let post = {
        API_Meth: "SavePatientNote",
        PatientNote: this.message,
        patientID: this.patient.externId,
        pname: this.patient.firstName + " " + this.patient.lastName,
        notify: this.notify,
        email: this.patient.email,
        name: this.allData.manager
          ? this.allData.manager.name
          : this.user.firstName + " " + this.user.lastName,
        startDt: this.startDt,
        endDt: this.endDt,
        startTime: this.startTime,
        endTime: this.endTime,
        type: this.noteType,
        timeLength:
          this.noteType == "9898X" || this.noteType == "9945X" ? this.runningTime : null,
      };
      await axios
        .post(CURR_API + "/tswebhook.php", post, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          // console.log(res)
          if (res.data.msg && res.data.msg == "Inserted") {
            if (this.selectedGroup == 0) {
              alert(
                "The note for " +
                  this.patient.firstName +
                  " " +
                  this.patient.lastName +
                  " has been saved."
              );
              let note = document.getElementById("note__popup" + this.patient.id);
              note.style.display = "none";
              this.noteTemplateSelector = "Templates";
              this.message = "";
              this.startTime = this.endTime = null;
              let today = new Date().toISOString().substring(0, 10);
              this.startDt = today;
              this.endDt = today;
            } else {
              this.sendGroupEmail();
            }
          } else {
            alert(
              "There was an error in saving the note. Please try again or contact a website administrator."
            );
          }
        });
      let draftDel = {
        userid: this.user.id,
        patientid: this.patient.id + "",
      };
      deleteNotes(draftDel).then((res) => {
        // console.log(res)
      });
      this.getAllNotes();
      loader.hide();
      loader = null;
      this.runningTime = 0;
      clearInterval(this.interval);
    },
  },
};
</script>

<style>
/* @import "/keyon"; */
.mboxtitle {
  display: flex;
}

.notesTitle {
  margin-left: 5%;
}

.startDateTime,
.endDateTime {
  display: flex;
  justify-content: flex-end;
}

.header-title {
  cursor: move;
}

.header-first {
  display: flex;
  justify-content: space-between;
  margin-top: 1%;
  margin-bottom: 1%;
  margin-left: 1%;
}

.text-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.5);
  flex-direction: column;
}

.text-content {
  background-color: #e6faff;
  padding: 20px;
  border-radius: 5px;
  z-index: 99999;
  text-align: left;
}

.outer-container {
  overflow: scroll;
  overflow-wrap: anywhere;
  max-height: 80%;
  width: 100%;
}

.btn-group {
  width: 100%;
}

.notebtn {
  background-color: #007bff !important;
}

.noteTimer {
  float: left;
  margin-left: 1%;
  margin-top: 1%;
}
</style>
